import { useMutation } from "react-query";

import { RegistrationBody } from "@bcasmart/doxecure-commons/doxecureClientTypes";

import { signup } from "@services/authentication.service";

const useRegister = () => useMutation((body: RegistrationBody) => signup(body));

export default useRegister;
